export default __webpack_public_path__ + "static/media/carteira.7cdfd7a7.jpg";